module.exports = __webpack_public_path__ + "img/play.8c3ca463.svg";